<div class="login-outer-container">

    <div class="login-container">

      <div>
        <h2 class="no-select">{{ 'login.title' | translate }}</h2>
      </div>

      <div class="login-error-container" *ngIf="!!errorMessage">
        <p class="no-select" class="error-message">{{ errorMessage }}</p>
      </div>

      <mat-tab-group dynamicHeight>
        <mat-tab label="{{ 'login.method.emailCode' | translate }}">

          <div class="login-form">
          <ng-container *ngIf="emailCodeSent else emailCodeNotSentYet">
            <form [formGroup]="emailCodeLoginForm" (ngSubmit)="verifyEmailCode()">
              <div class="login-method-hint">
                {{ 'login.emailCodeSent' | translate }}
              </div>
              <mat-form-field>
                <input type="text" matInput formControlName="code"
                       autocomplete="off"
                       placeholder="{{ 'login.emailCode' | translate }}">
              </mat-form-field>

              <button type="submit" [disabled]="emailCodeLoginForm.invalid || loading" mat-flat-button color="primary">{{ 'login.verifyEmailCode' | translate }}</button>
            </form>
          </ng-container>

          <ng-template #emailCodeNotSentYet>
            <form [formGroup]="emailLoginForm" (ngSubmit)="sendEmailCode()">
              <div class="login-method-hint">
                {{ 'login.emailCodeHint' | translate }}
              </div>
              <mat-form-field appearance="outline">
                <mat-label>{{ 'login.emailAddress' | translate }}</mat-label>
                <input type="email" matInput formControlName="email">
              </mat-form-field>

              <button type="submit" [disabled]="emailLoginForm.invalid || loading" mat-flat-button color="primary">{{ 'login.sendEmailCode' | translate }}</button>
            </form>
          </ng-template>
          </div>
        </mat-tab>
        <mat-tab label="{{ 'login.method.password' | translate }}">
          <div class="login-form">
          <form [formGroup]="passwordLoginForm" (ngSubmit)="signInWithPassword()">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'login.emailAddress' | translate }}</mat-label>
              <input type="email" matInput formControlName="email">
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>{{ 'login.password' | translate }}</mat-label>
              <input type="password" formControlName="password" matInput>
            </mat-form-field>

            <button type="submit" [disabled]="passwordLoginForm.invalid || loading" mat-flat-button color="primary">{{ 'login.signIn' | translate }}</button>
          </form>

          <div class="password-reset-container">
            <a class="no-select" routerLink="/forgot-password">{{ 'login.forgotPassword' | translate }}</a>
          </div>
          </div>
        </mat-tab>
      </mat-tab-group>
      &nbsp;
      <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

      <p class="no-select" class="environment-hint">Version {{ appVersion }} <span *ngIf="!!envHint"> - {{ envHint }}</span></p>
    </div>

</div>
